import isUndefined from "lodash/isUndefined";
import isNull from "lodash/isNull";
const nonEmptyItem = (item) => {
  return !isUndefined(item) && !isNull(item);
};
export {
  nonEmptyItem
};
